import { Component, Input, OnInit } from '@angular/core';
import { BRAIN_PAGE, BrainData } from '../common';
import {
	SelectListCustom,
	SelectListNext,
	SelectListOption,
} from '@components';
import {
	LanguageService,
	MainKey,
	MAIN_KEY_PREFIX,
	StorageService,
	TempKey,
} from '@services/public';
import { ReplaySubject, Subscription } from 'rxjs';
import { ExposedPromise } from 'jakapa-utilities-lite';

const PAGE_PATH: string = 'skillBuilders.brain.pages.affirmations';

@Component({
	selector: 'app-member-skill-builder-brain-affirmations',
	templateUrl: './affirmations.component.html',
	styleUrls: ['./affirmations.component.scss'],
})
export class MemberSkillBuilderBrainAffirmationsComponent implements OnInit {
	@Input() data: BrainData;
	options: ReplaySubject<Array<SelectListOption>> = new ReplaySubject<
		Array<SelectListOption>
	>(1);
	defaultOptions: Array<SelectListOption> = [];
	customOptions: Array<SelectListOption> = [];
	custom: SelectListCustom = {
		add: this.addCustom.bind(this),
		delete: this.deleteCustom.bind(this),
	};
	next: SelectListNext = {
		onClick: this.nextOnClick.bind(this),
	};
	defaultLoaded: ExposedPromise<void> = new ExposedPromise<void>();
	private _subscriptions: Subscription = new Subscription();

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
	};

	constructor(
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page) {
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
			}
		});

		// Get options list.
		const path: string = 'skillBuilders.brain.affirmations';
		this._languageSvc.get([path]).then((value) => {
			if (typeof value[path] === 'object' && value[path] !== null)
				this.defaultOptions = Object.values(value[path]);
			this.defaultLoaded.resolve();
		});
		this._subscriptions.add(
			this._storageSvc.updates.subscribe((update) => {
				if (update.key === MAIN_KEY_PREFIX + MainKey.ALL) {
					this.customOptions = [];
					if (Array.isArray(update.value[MainKey.BRAIN_AFFIRMATIONS])) {
						for (const option of update.value[MainKey.BRAIN_AFFIRMATIONS]) {
							if (typeof option !== 'string') continue;
							this.customOptions.push({ display: option, custom: true });
						}
					}
					this._mergeAndSelectOptions();
				}
				if (update.key === MAIN_KEY_PREFIX + MainKey.CLEAR) {
					this.customOptions = [];
					this._mergeAndSelectOptions();
				}
				if (update.key === MAIN_KEY_PREFIX + MainKey.BRAIN_AFFIRMATIONS) {
					this.customOptions = [];
					if (Array.isArray(update.value)) {
						for (const option of update.value) {
							if (typeof option !== 'string') continue;
							this.customOptions.push({ display: option, custom: true });
						}
					}
					this._mergeAndSelectOptions();
				}
			}),
		);
		let options: Array<string> = this._storageSvc.getMainStorage(
			MainKey.BRAIN_AFFIRMATIONS,
		);
		if (Array.isArray(options)) {
			for (const option of options) {
				if (typeof option !== 'string') continue;
				this.customOptions.push({ display: option, custom: true });
			}
		}

		this._mergeAndSelectOptions();
	}

	private async _mergeAndSelectOptions(): Promise<void> {
		await this.defaultLoaded;
		this.options.next(
			[...this.customOptions, ...this.defaultOptions].map(
				(value: SelectListOption) => {
					if (value.display === this.data?.affirmation)
						return { ...value, selected: true };
					return value;
				},
			),
		);
	}

	addCustom(customOption: string): void {
		if (
			this.customOptions.findIndex(
				(option) => option.display === customOption,
			) !== -1
		)
			return;
		if (
			this.defaultOptions.findIndex(
				(option) => option.display === customOption,
			) !== -1
		)
			return;
		this.customOptions.push({ display: customOption, custom: true });
		this._storageSvc.setMainStorage(
			MainKey.JOURNAL_EMOTIONS,
			this.customOptions.map((option) => option.display),
		);
	}

	deleteCustom(option: SelectListOption): void {
		this.customOptions = this.customOptions.filter(
			(customOption) => customOption.display !== option.display,
		);
		if (this.customOptions.length === 0)
			this._storageSvc.setMainStorage(MainKey.JOURNAL_EMOTIONS, null);
		else
			this._storageSvc.setMainStorage(
				MainKey.JOURNAL_EMOTIONS,
				this.customOptions.map((option) => option.display),
			);
	}

	nextOnClick(option: SelectListOption): void {
		this._storageSvc.setTempStorage(TempKey.BRAIN, {
			...this.data,
			page: BRAIN_PAGE.DIARY,
			affirmation: option.display,
		});
	}
}
